import React, { useState } from "react";
import * as S from "./accordion.style";
import { AccordionProps } from "./accordion.types";

const Accordion: React.FC<AccordionProps> = ({ items }) => {
	const [openIndex, setOpenIndex] = useState<number | null>(null);

	const handleItemClick = (index: number) => {
		setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
	};

	return (
		<S.AccordionContainer>
			{items.map((item, index) => (
				<S.AccordionItemContainer key={item.id}>
					<S.AccordionItemHeader onClick={() => handleItemClick(index)}>
						<span>{item.title}</span>
						<span>{openIndex === index ? "▲" : "▼"}</span>
					</S.AccordionItemHeader>
					<S.AccordionItemContent isOpen={openIndex === index}>
						{item.content}
					</S.AccordionItemContent>
				</S.AccordionItemContainer>
			))}
		</S.AccordionContainer>
	);
};

export default Accordion;
